const adventuresList = [
  {
    id: 0,
    title: "The Ice Prison",
    img: "adventure-images/dungeon-01.webp",
    bp: 1000,
    enemies: [
      {
        title: "Ice Golem",
        img: "enemy-images/crystal.webp",
        hp: 500,
        speed: 1,
        damage: 10,
        drop: 100,
      },
      {
        title: "Fast Ice Golem",
        img: "enemy-images/crystal-fast.webp",
        hp: 420,
        speed: 2,
        damage: 5,
        drop: 100,
      },
      {
        title: "Strong Ice Golem",
        img: "enemy-images/crystal-strong.webp",
        hp: 1000,
        speed: 0.5,
        damage: 20,
        drop: 100,
      },
    ],
    rooms: 8,
    boss: {
      title: "Icicle",
      img: "enemy-images/crystal-boss.webp",
      hp: 2000,
      speed: 1.2,
      damage: 10,
      drop: 250,
    },
    bossLoot: [
      { title: "Upgrade scroll +1", chance: 50 },
      { title: "Silver ring", chance: 10 },
      { title: "Leather glove", chance: 10 },
    ],
  },
  {
    id: 1,
    title: "The Lair of the Rotters",
    img: "adventure-images/dungeon-02.webp",
    bp: 5000,
    enemies: [
      {
        title: "Agaric",
        img: "enemy-images/mushroom.webp",
        hp: 4000,
        speed: 1,
        damage: 40,
        drop: 150,
      },
      {
        title: "Fast Agaric",
        img: "enemy-images/mushroom-fast.webp",
        hp: 3800,
        speed: 3.5,
        damage: 15,
        drop: 150,
      },
      {
        title: "Strong Agaric",
        img: "enemy-images/mushroom-strong.webp",
        hp: 5000,
        speed: 0.9,
        damage: 50,
        drop: 150,
      },
    ],
    rooms: 8,
    boss: {
      title: "Sporus",
      img: "enemy-images/mushroom-boss.webp",
      hp: 6000,
      speed: 1.1,
      damage: 55,
      drop: 390,
    },
    bossLoot: [
      { title: "Upgrade scroll +1", chance: 100 },
      { title: "Upgrade scroll +1", chance: 50 },
      { title: "Silver helmet", chance: 5 },
      { title: "Silver Necklace", chance: 5 },
    ],
  },
  {
    id: 2,
    title: "Necropolis",
    img: "adventure-images/dungeon-03.webp",
    bp: 10000,
    enemies: [
      {
        title: "Infected Henchman",
        img: "enemy-images/zombie.webp",
        hp: 8000,
        speed: 0.5,
        damage: 180,
        drop: 220,
      },
      {
        title: "Fast Henchman",
        img: "enemy-images/zombie-fast.webp",
        hp: 6500,
        speed: 3,
        damage: 40,
        drop: 220,
      },
      {
        title: "Strong Henchman",
        img: "enemy-images/zombie-strong.webp",
        hp: 10000,
        speed: 0.8,
        damage: 100,
        drop: 220,
      },
    ],
    rooms: 8,
    boss: {
      title: "Lord of Decay",
      img: "enemy-images/zombie-boss.webp",
      hp: 15000,
      speed: 2,
      damage: 75,
      drop: 400,
    },
    bossLoot: [
      { title: "Upgrade scroll +1", chance: 100 },
      { title: "Upgrade scroll +1-3", chance: 50 },
      { title: "Green ring", chance: 10 },
      { title: "Metal glove", chance: 10 },
    ],
  },
  {
    id: 3,
    title: "The Crypt",
    img: "adventure-images/dungeon-04.webp",
    bp: 20000,
    enemies: [
      {
        title: "Knuckle",
        img: "enemy-images/skeleton.webp",
        hp: 16000,
        speed: 1.2,
        damage: 180,
        drop: 250,
      },
      {
        title: "Fast Knuckle",
        img: "enemy-images/skeleton-fast.webp",
        hp: 12000,
        speed: 2.9,
        damage: 55,
        drop: 250,
      },
      {
        title: "Strong Knuckle",
        img: "enemy-images/skeleton-strong.webp",
        hp: 17000,
        speed: 0.9,
        damage: 200,
        drop: 250,
      },
    ],
    rooms: 8,
    boss: {
      title: "The Executioner",
      img: "enemy-images/skeleton-boss.webp",
      hp: 20000,
      speed: 1.2,
      damage: 150,
      drop: 420,
    },
    bossLoot: [
      { title: "Upgrade scroll +1-3", chance: 100 },
      { title: "Helmet of Nature", chance: 10 },
      { title: "Tear of the Earth", chance: 10 },
    ],
  },
  {
    id: 4,
    title: "The Plague Citadel",
    img: "adventure-images/dungeon-05.webp",
    bp: 40000,
    enemies: [
      {
        title: "Miner",
        img: "enemy-images/ork.webp",
        hp: 35000,
        speed: 1.05,
        damage: 300,
        drop: 275,
      },
      {
        title: "Fast Miner",
        img: "enemy-images/ork-fast.webp",
        hp: 25000,
        speed: 2.5,
        damage: 75,
        drop: 275,
      },
      {
        title: "Strong Miner",
        img: "enemy-images/ork-strong.webp",
        hp: 40000,
        speed: 0.85,
        damage: 250,
        drop: 275,
      },
    ],
    rooms: 8,
    boss: {
      title: "Lord of Darkness",
      img: "enemy-images/pixel-boss.webp",
      hp: 55000,
      speed: 1.7,
      damage: 250,
      drop: 445,
    },
    bossLoot: [
      { title: "Upgrade scroll +1-3", chance: 100 },
      { title: "Upgrade protect", chance: 25 },
      { title: "Blue ring", chance: 10 },
      { title: "Metal magic glove", chance: 10 },
    ],
  },
  {
    id: 5,
    title: "The Tower of Wizards",
    img: "adventure-images/dungeon-06.webp",
    bp: 70000,
    enemies: [
      {
        title: "Librarian",
        img: "enemy-images/mage.webp",
        hp: 65000,
        speed: 0.85,
        damage: 750,
        drop: 300,
      },
      {
        title: "Phantom Librarian",
        img: "enemy-images/mage-fast.webp",
        hp: 55000,
        speed: 2.1,
        damage: 260,
        drop: 300,
      },
      {
        title: "Guardian Librarian",
        img: "enemy-images/mage-strong.webp",
        hp: 75000,
        speed: 0.6,
        damage: 500,
        drop: 275,
      },
    ],
    rooms: 8,
    boss: {
      title: "The Last Archmage",
      img: "enemy-images/mage-boss.webp",
      hp: 120000,
      speed: 1.7,
      damage: 300,
      drop: 475,
    },
    bossLoot: [
      { title: "Upgrade scroll +1-3", chance: 100 },
      { title: "Upgrade scroll +1-3", chance: 50 },
      { title: "Upgrade scroll +1-3", chance: 50 },
      { title: "Upgrade protect", chance: 20 },
      { title: "Upgrade luck", chance: 20 },
      { title: "Golden Era", chance: 10 },
      { title: "The Eye of the Elemental", chance: 10 },
    ],
  },
  {
    id: 6,
    title: "Abandoned Keep",
    img: "adventure-images/dungeon-07.webp",
    bp: 100000,
    enemies: [
      {
        title: "Stone Golem",
        img: "enemy-images/golem.webp",
        hp: 99800,
        speed: 1,
        damage: 800,
        drop: 330,
      },
      {
        title: "Fast Stone Golem ",
        img: "enemy-images/golem-fast.webp",
        hp: 80000,
        speed: 1.9,
        damage: 500,
        drop: 330,
      },
      {
        title: "Strong Stone Golem ",
        img: "enemy-images/golem-strong.webp",
        hp: 120000,
        speed: 0.8,
        damage: 900,
        drop: 330,
      },
    ],
    rooms: 8,
    boss: {
      title: "Architect of Ruin",
      img: "enemy-images/golem-boss.webp",
      hp: 200000,
      speed: 1.05,
      damage: 1000,
      drop: 500,
    },
    bossLoot: [
      { title: "Upgrade scroll +1-3", chance: 50 },
      { title: "Upgrade protect", chance: 25 },
      { title: "Upgrade luck", chance: 25 },
      { title: "Purple ring", chance: 10 },
    ],
  },
  {
    id: 7,
    title: "Mines of Eternal",
    img: "adventure-images/dungeon-08.webp",
    bp: 150000,
    enemies: [
      {
        title: "The Crystal Guardian",
        img: "enemy-images/gem.webp",
        hp: 148000,
        speed: 1.5,
        damage: 700,
        drop: 350,
      },
      {
        title: "Fast Crystal Imp",
        img: "enemy-images/gem-fast.webp",
        hp: 130000,
        speed: 2.2,
        damage: 450,
        drop: 350,
      },
      {
        title: "Strong Crystal Imp ",
        img: "enemy-images/gem-strong.webp",
        hp: 180000,
        speed: 0.6,
        damage: 2000,
        drop: 350,
      },
    ],
    rooms: 8,
    boss: {
      title: "Sparkling Jack",
      img: "enemy-images/gem-boss.webp",
      hp: 220000,
      speed: 1.5,
      damage: 1500,
      drop: 550,
    },
    bossLoot: [
      { title: "Upgrade scroll +1-3", chance: 100 },
      { title: "Upgrade scroll +1-3", chance: 50 },
      { title: "Upgrade scroll +1-3", chance: 50 },
      { title: "Upgrade protect", chance: 25 },
      { title: "Upgrade luck", chance: 25 },
      { title: "Magic glove", chance: 10 },
    ],
  },
  {
    id: 8,
    title: "Lavaland",
    img: "adventure-images/dungeon-09.webp",
    bp: 220000,
    enemies: [
      {
        title: "Magmastic",
        img: "enemy-images/lava.webp",
        hp: 190000,
        speed: 1.2,
        damage: 2100,
        drop: 420,
      },
      {
        title: "Fast Magmastic",
        img: "enemy-images/lava-fast.webp",
        hp: 160000,
        speed: 4,
        damage: 490,
        drop: 550,
      },
      {
        title: "Strong Magmastic",
        img: "enemy-images/lava-strong.webp",
        hp: 250000,
        speed: 1,
        damage: 1500,
        drop: 600,
      },
    ],
    rooms: 8,
    boss: {
      title: "The Guardian of the Core",
      img: "enemy-images/lava-boss.webp",
      hp: 400000,
      speed: 1.5,
      damage: 1900,
      drop: 900,
    },
    bossLoot: [
      { title: "Upgrade scroll +1-3", chance: 100 },
      { title: "Upgrade scroll +1-3", chance: 50 },
      { title: "Upgrade scroll +1-3", chance: 50 },
      { title: "Upgrade protect", chance: 25 },
      { title: "Upgrade luck", chance: 25 },
      { title: "Fate", chance: 5 },
    ],
  },
  {
    id: 9,
    title: "Fox Forest",
    img: "adventure-images/dungeon-10.webp",
    bp: 400000,
    enemies: [
      {
        title: "The Mad Fox",
        img: "enemy-images/fox.webp",
        hp: 320000,
        speed: 1.5,
        damage: 2100,
        drop: 480,
      },
      {
        title: "Fast Mad Fox",
        img: "enemy-images/fox-fast.webp",
        hp: 280000,
        speed: 3.5,
        damage: 700,
        drop: 590,
      },
      {
        title: "Strong Mad Fox",
        img: "enemy-images/fox-strong.webp",
        hp: 350000,
        speed: 0.8,
        damage: 2650,
        drop: 650,
      },
    ],
    rooms: 8,
    boss: {
      title: "Moonlight",
      img: "enemy-images/fox-boss.webp",
      hp: 600000,
      speed: 1.65,
      damage: 3000,
      drop: 1000,
    },
    bossLoot: [
      { title: "Upgrade scroll +1-3", chance: 100 },
      { title: "Upgrade scroll +1-3", chance: 50 },
      { title: "Upgrade scroll +1-3", chance: 50 },
      { title: "Upgrade protect", chance: 25 },
      { title: "Upgrade luck", chance: 25 },
      { title: "Shadow Helmet", chance: 10 },
    ],
  },
];

export default adventuresList;
